export default __webpack_public_path__ + "static/media/notice.3d08d5ca.png";